import { render, staticRenderFns } from "./MonthlyReport.vue?vue&type=template&id=2d52b479&scoped=true&"
import script from "./MonthlyReport.vue?vue&type=script&lang=js&"
export * from "./MonthlyReport.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyReport.vue?vue&type=style&index=0&id=2d52b479&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d52b479",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBadge,VCard,VChip,VIcon,VSimpleTable})
